function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "red",
  d: "M0 0h32v32H0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M6 13h20v6H6z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M13 6h6v20h-6z"
});

var SvgFlagSwiss = function SvgFlagSwiss(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPjxyZWN0IGZpbGw9IiNmMDAiIGhlaWdodD0iMzIiIHdpZHRoPSIzMiIvPjxyZWN0IGZpbGw9IiNmZmYiIGhlaWdodD0iNiIgd2lkdGg9IjIwIiB4PSI2IiB5PSIxMyIvPjxyZWN0IGZpbGw9IiNmZmYiIGhlaWdodD0iMjAiIHdpZHRoPSI2IiB4PSIxMyIgeT0iNiIvPjwvc3ZnPg==";
export { SvgFlagSwiss as ReactComponent };